module.exports = __webpack_public_path__ + "img/homeBanner.9e649f70.png";